<<template>
  <div class="smy__card-full-box page-org">
    <Card
      class="smy__card-full"
      :bordered="false"
      :padding="0"
    >
    <p slot="title">
      账号管理
    </p>
    <p slot="extra" class="extra">
    </p>
    <div class="top">
      <div class="top-right" style="float:right;padding:17px 17px 0">
        <Button
          type="primary"
          class="search-button"
          @click="showAddModel(1)"
        >新增子管理员</Button>

        <Button
          type="primary"
          class="search-button"
          style="margin-left:10px;"
          @click="showAddModel(2)"
        >新增业务员</Button>
      </div>
    </div>
    <div class="table" style="margin:17px">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
        @on-selection-change="selection = $event"
      />
    </div>
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
      style="margin-left:17px;"
    />
    <!-- 新增 -->
      <Modal
        v-model="editListModal"
        width="700"
        :title="sysroleText"
        :mask-closable="false"
        :loading="modalLoading"
        @on-ok="editList('editListForm')"
      >
      <Form
        ref="editListForm"
        label-position="right"
        :label-width="80"
        :rules="ruleValidate"
        :model="editListForm"
      >
      <FormItem label="姓名"
        prop="name"
        label-for="name"
      >
        <Input
          placeholder="请输入姓名"
          element-id="name"
          v-model="editListForm.name"
        ></Input>
      </FormItem>
      <FormItem label="手机号"
        prop="phone"
        label-for="phone"
      >
        <Input
          placeholder="请输入手机号"
          element-id="phone"
          v-model="editListForm.phone"
        ></Input>
      </FormItem>
      <template v-if="edit === 1">
        <FormItem label="账号"
          prop="loginName"
          label-for="loginName"
        >
          <Input
            placeholder="请输入账号"
            element-id="loginName"
            v-model="editListForm.loginName"
          ></Input>
        </FormItem>
        <FormItem label="初始密码"
          prop="password"
          label-for="password"
        >
          <Input
            placeholder="请输初始密码"
            element-id="password"
            type="password"
            v-model="editListForm.password"
          ></Input>
        </FormItem>
      </template>
      <template v-if="edit === 2">
      <FormItem label="账号"
      >
        <span>{{editListForm.loginName}}</span>
      </FormItem>
      <FormItem label="密码"
      v-if="edit === 2"
      >
        <a href="javascript:;" @click="visible = true">重置密码</a>
      </FormItem>
     </template>
    </Form>
  </Modal>
  <!-- 重置密码 -->
      <Modal
      :mask-closable="false"
      :loading="modalLoading"
      v-model="visible"
      @on-ok="resetPassword('resetLostForm')"
      title="重置密码">
         <Form
         label-position="right"
         ref="resetLostForm"
         :model="resetLostForm"
         :rules="ruleRest"
         :label-width="80">
          <FormItem
            label="重置密码"
            prop="password"
            label-for="password"
          >
            <Input
             type="password"
             v-model="resetLostForm.password"
             placeholder=""></Input>
          </FormItem>
        </Form>
      </Modal>
    </Card>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data () {
    const validateMobile = (rule, value, callback) => {
      if (!value.match(/[0-9-()（）]{7,15}/)) {
        callback(new Error('请输入正确的联系电话类型'))
      } else {
        callback()
      }
    }
    return {
      resetLostForm: {
        password: ''
      },
      pageSize: 10,
      pageIndex: 0,
      listLoading: false,
      edit: 1,
      count: 0,
      list: [],
      modalLoading: true,
      resetlLoading: true,
      editListModal: false, // 导出对话框
      visible: false, // 修改密码
      sysroleText: '新增管理员',
      editListForm: {
        id: '',
        name: '',
        phone: '',
        loginName: '',
        password: '',
        sysrole: 4
      },
      ruleRest: {
        password: [
          { required: true, message: '请输入最少6位密码', type: 'string', trigger: 'blur' }
        ]
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入姓名', type: 'string', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          { validator: validateMobile, trigger: 'blur' },
          { max: 13, message: '请正确的联系电话', trigger: 'blur' }
        ],
        loginName: [
          { required: true, message: '请输入账号', type: 'string', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入最少6位密码', type: 'string', trigger: 'blur', min: 6 }
        ]
      }
    }
  },
  computed: {
    ...mapState('table', [
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 160,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let deleteBtn = h('Poptip', {
              props: {
                confirm: true,
                title: '确认删除此内容吗？',
                width: 160,
                transfer: true
              },
              on: {
                'on-ok': () => this.deleteList(row.id)
              }
            }, [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginLeft: '10px'
                }
              }, ['删除'])
            ])
            let editBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  for (let obj in this.editListForm) {
                    this.editListForm[obj] = ''
                  }
                  this.edit = 2
                  this.editListForm.id = row.id
                  this.sysroleText = '编辑资料'
                  this.editListModal = true
                  this.editListForm.name = row.name
                  this.editListForm.phone = row.phone
                  this.editListForm.loginName = row.loginName
                  this.editListForm.sysrole = row.sysrole
                }
              }
            }, ['编辑资料'])
            if (row.isMain === 1) {
              return h('span', [editBtn])
            } else {
              return h('span', [
                editBtn,
                deleteBtn
              ])
            }
          }
        },
        {
          title: '姓名',
          key: 'name',
          width: 140
        },
        {
          title: '电话号码',
          key: 'phone',
          width: 140
        },
        {
          title: '账号',
          key: 'loginName',
          width: 120
        },
        {
          title: '账号类型',
          key: 'sysrole',
          width: 120,
          render: (h, {row}) => {
            let priority = row.sysrole
            let priorityName = ''
            if (priority === 1 && row.isMain === 1) {
              priorityName = '主管理员'
            } else if (priority === 1 && row.isMain === 0) {
              priorityName = '子管理员'
            } else if (priority === 2) {
              priorityName = '渠道经理'
            } else if (priority === 3) {
              priorityName = '财务经理'
            } else if (priority === 4) {
              priorityName = '代理商管理员'
            } else if (priority === 5) {
              priorityName = '代理商业务员'
            }
            return h('span', [priorityName])
          }
        },

        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/user/list', {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        }),
        this.$http.get('/user/count', {
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = (pageIndex - 1)
      this.loadList()
    },
    // 显示新增弹窗
    showAddModel (val) {
      this.edit = 1
      for (let obj in this.editListForm) {
        this.editListForm[obj] = ''
      }
      if (val === 1) {
        this.sysroleText = '新增子管理员'
        this.editListForm.sysrole = 4
      }
      if (val === 2) {
        this.sysroleText = '新增业务员'
        this.editListForm.sysrole = 5
      }
      this.editListModal = true
    },
    // 删除操作
    deleteList (itemId) {
      let url = `/user?id=${itemId}`
      this.$http.delete(url).then(res => {
        if (res.success) {
          this.$Message.success('删除成功')
          this.loadList()
        } else {
          this.$Message.warning(res.message)
        }
      })
    },
    // 修改密码
    resetPassword (val) {
      this.resetlLoading = false
      setTimeout(() => {
        this.resetlLoading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            password: this.resetLostForm.password,
            id: this.editListForm.id
          }
          let url = '/user'
          this.$http.put(url, data).then(res => {
            if (res.success) {
              let msg = '重置密码成功'
              this.loadList()
              this.$Message.success(msg)
              this.visible = false
              this.editListModal = false
              this.resetLostForm.password = ''
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    // 保存编辑数据
    editList (val) {
      this.modalLoading = false
      setTimeout(() => {
        this.modalLoading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            ...this.editListForm
          }
          let url = '/user'
          if (this.editListForm.id) {
            this.$http.put(url, data).then(res => {
              if (res.success) {
                let msg = '修改成功'
                this.loadList()
                this.$Message.success(msg)
                this.editListModal = false
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            this.$http.post(url, data).then(res => {
              if (res.success) {
                let msg = '新增成功'
                this.loadList()
                this.$Message.success(msg)
                this.editListModal = false
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
  .table {
    margin: 17px;
  }

  .page {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/accountManage/agAccountManages/index.vue